export default {
  google:  require('@/assets/images/search-engines/google.png'),
  bing:    require('@/assets/images/search-engines/bing.png'),
  yahoo:   require('@/assets/images/search-engines/yahoo.png'),
  youtube: require('@/assets/images/search-engines/youtube.png'),
}
